function VideoOff({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.98969 6.56993L5.98969 4.56993L1.83969 0.429932L0.429688 1.83993L3.15969 4.56993H2.42969C1.87969 4.56993 1.42969 5.01993 1.42969 5.56993V15.5699C1.42969 16.1199 1.87969 16.5699 2.42969 16.5699H14.4297C14.6397 16.5699 14.8197 16.4899 14.9797 16.3899L18.1597 19.5699L19.5697 18.1599L10.7097 9.29993L7.98969 6.56993ZM3.42969 14.5699V6.56993H5.15969L13.1597 14.5699H3.42969ZM13.4297 6.56993V9.17993L19.4297 15.1799V5.06993L15.4297 9.06993V5.56993C15.4297 5.01993 14.9797 4.56993 14.4297 4.56993H8.81969L10.8197 6.56993H13.4297Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default VideoOff;
